module.exports = __webpack_public_path__ + "img/apply-icon.343e375c.png";